import { API_BASE_URL } from "../../constants";

export const createRegion = async (name, imageFile) => {
    try {
        const formData = new FormData();
        formData.append("name", name);
        formData.append("image", imageFile);

        const response = await fetch(`${API_BASE_URL}api/datasettings/regions`, {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            throw new Error("Failed to create region");
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error creating region:", error);
        throw error;
    }
};


export const getRegions = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}api/datasettings/regions`, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Failed to fetch regions");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching regions:", error);
        throw error;
    }
};

export const editRegion = async (regionId, name, imageFile, isDefaultRegion) => {
    try {
        const formData = new FormData();
        formData.append("name", name);
        formData.append("isDefault", isDefaultRegion ? "true" : "false");

        if (imageFile) {
            formData.append("image", imageFile);
        }

        const response = await fetch(`${API_BASE_URL}api/datasettings/regions/${regionId}`, {
            method: "PUT",
            body: formData,
        });

        if (!response.ok) {
            throw new Error("Failed to update region");
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error updating region:", error);
        throw error;
    }
};


export const deleteRegion = async (regionId) => {
    try {
        const response = await fetch(`${API_BASE_URL}api/datasettings/regions/${regionId}`, {
            method: "DELETE",
        });

        if (!response.ok) {
            throw new Error("Failed to delete region");
        }

        return true;
    } catch (error) {
        console.error("Error deleting region:", error);
        throw error;
    }
};